// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".chunk.js?v=32646821913&enable_js_minification=1";
};